import React from "react";
import ReactSVG from "react-svg";
import { Grid } from "@material-ui/core";
import { Margin, Title, Text } from "~/components/elements";
import EditSVG from "~/assets/img/icon/editar.svg";
import ArrowRight from "~/assets/img/icon/arrowRightBlack.svg";
import { Link } from "react-router-dom";
import * as S from "./styles";
import { genderSelect, ufSelect } from "~/utils/variables";
import { formatDateView } from "~/utils/tools";
import { AccountPersonal, AccountContact, AccountCommunication } from "..";

export default function AccountMain({
  mobile,
  personalData,
  contactData,
  editClick,
  handleModal,
  resendConfirmNewEmail,
  emailValidated,
  setEdit,
  menuClick,
  edit,
}) {
  const returnGender = (value) => {
    return genderSelect.find((gender) => gender.value === value)?.label;
  };

  const returnUf = (value) => {
    return ufSelect.find((uf) => uf.value === value)?.label;
  };

  return (
    <>
      <Margin mb={mobile ? 4 : 12}>
        <Grid container justifyContent="space-between">
          <S.AccountCard>
            <Margin mb={1}>
              <Title as="3" level="6">
                Datos personales
              </Title>
            </Margin>
            <Margin sm={9}>
              {edit === 1 ? (
                <AccountPersonal
                  mobile={mobile}
                  personalData={personalData}
                  setEdit={setEdit}
                  menuClick={menuClick}
                  edit={edit}
                />
              ) : (
                <>
                  <S.CardAbstract>
                    <div>
                      <Margin mb={1}>
                        <Text level="2">Nombre completo</Text>
                      </Margin>
                      <Text primary level="1">
                        {personalData.Nome}
                      </Text>
                    </div>
                    <div>
                      <Margin mb={1}>
                        <Text level="2">Fecha de nacimiento</Text>
                      </Margin>
                      <Text primary level="1">
                        {formatDateView(personalData.DataNascimento)}
                      </Text>
                    </div>
                    <div>
                      <Margin mb={1}>
                        <Text level="2">Género</Text>
                      </Margin>

                      <Text primary level="1">
                        {returnGender(personalData.Sexo)}
                      </Text>
                    </div>
                    <div>
                      <Margin mb={1}>
                        <Text level="2">Región</Text>
                      </Margin>

                      <Text primary level="1">
                        {returnUf(personalData.Uf)}
                      </Text>
                    </div>
                  </S.CardAbstract>
                  <S.CardLink
                    onClick={() => editClick(1)}
                    id="accountEditPersonalLink"
                  >
                    <Grid
                      container
                      justifyContent="flex-end"
                      alignContent="center"
                    >
                      <S.IconMargin>
                        <ReactSVG src={EditSVG} />
                      </S.IconMargin>
                      <Text level="1">Editar datos</Text>
                    </Grid>
                  </S.CardLink>
                </>
              )}
            </Margin>
          </S.AccountCard>
          <S.AccountCard>
            <Margin mb={4}>
              <Title as="3" level="6">
                Detalles de contacto
              </Title>
            </Margin>
            <S.CardContact>
              {edit === 2 ? (
                <AccountContact
                  mobile={mobile}
                  contactData={contactData}
                  setEdit={setEdit}
                  menuClick={menuClick}
                  edit={edit}
                />
              ) : null}

              <div>
                <div>
                  <Margin mb={1}>
                    <Text level="2">Correo electrónico</Text>
                  </Margin>
                  <S.EmailLimiter>
                    <Text primary level="1">
                      {contactData.Email}
                    </Text>
                  </S.EmailLimiter>
                </div>
                <S.CardLinkHolder data-styled="CardLinkHolder">
                  {!emailValidated && (
                    <S.CardLink
                      onClick={() => resendConfirmNewEmail()}
                      id="accountResendConfirmLink"
                    >
                      <Grid
                        container
                        justifyContent="flex-end"
                        alignContent="flex-end"
                      >
                        <S.ResendEmail>
                          <Text level="1" as="strong" underline>
                            Reenviar verificación
                          </Text>
                        </S.ResendEmail>
                      </Grid>
                    </S.CardLink>
                  )}

                  <S.CardLink
                    onClick={() => handleModal("FormValidateLogin")}
                    id="accountEditContactLink"
                  >
                    <Grid
                      container
                      justifyContent="space-between"
                      alignContent="flex-end"
                    >
                      <S.IconMargin>
                        <ReactSVG src={EditSVG} />
                      </S.IconMargin>
                      <Text level="1">Cambiar e-mail</Text>
                    </Grid>
                  </S.CardLink>
                </S.CardLinkHolder>
              </div>
            </S.CardContact>
          </S.AccountCard>
          <S.TitleHolder>
            <Margin mt={2} mb={2}>
              <Title as="3" level="6" primary emphasis>
                Contraseña registrada
              </Title>
            </Margin>
          </S.TitleHolder>
          <S.UpdatePasswordCard>
            <Grid
              container
              justifyContent="space-between"
              alignContent="flex-start"
            >
              <Title as="3" level="6" emphasis primary>
                Actualizar contraseña
              </Title>
              <S.UpdatePasswordActions>
                <Text level="1">
                  Has clic en Actualizar contraseña para cambiar tu contraseña y
                  actualizar tu cuenta.
                </Text>
                <Link to="/atualizar-senha">
                  <Text as="span" level="1">
                    Actualizar contraseña
                  </Text>
                  <ReactSVG wrapper="span" src={ArrowRight} />
                </Link>
              </S.UpdatePasswordActions>
            </Grid>
          </S.UpdatePasswordCard>
          <S.Comunication>
            <Margin mb={4}>
              <Title as="3" level="6" emphasis primary>
                Preferencias
              </Title>
            </Margin>
            <AccountCommunication />
          </S.Comunication>
          <S.ContactUs>
            <Text level="1" primary>
              Si deseas ajustar alguna información que no obtuviste aquí, por
              favor,{" "}
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.neutrogena.cl/contactanos"
              >
                Contáctanos.
              </a>
            </Text>
          </S.ContactUs>
        </Grid>
      </Margin>
    </>
  );
}
